var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{staticClass:"px-2 ma-0"},[_c('header-center',{attrs:{"isLoading":_vm.isLoading,"dataProfile":_vm.dataProfile}}),_c('notifications',{attrs:{"center":_vm.center,"isLoading":_vm.isLoading,"hasShadow":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }